/**
 *
 */
export enum MeterNodeLabel {
    METER = "Meter",
}